import api from '@/services/api';

export function listLetters({ page = 1, limit = 20, q = '' } = {}) {
    const params = new URLSearchParams({ page, limit });
    if (q) params.set('q', q);
    return api.get(`/feedback-letters?${params.toString()}`).then(r => r.data);
}

export function getLetter(id) {
    return api.get(`/feedback-letters/${id}`).then(r => r.data);
}

export function getLetterDetail(id) {
    return api.get(`/feedback-letters/${id}/detail`).then(r => r.data);
}

export function createLetter(payload) {
    return api.post('/feedback-letters', payload).then(r => r.data);
}

export function updateLetter(id, payload) {
    return api.put(`/feedback-letters/${id}`, payload).then(r => r.data);
}

export function deleteLetter(id) {
    return api.delete(`/feedback-letters/${id}`).then(r => r.data);
}

export function getLetterStudents(id) {
    return api.get(`/feedback-letters/${id}/students`).then(r => r.data);
}

export function setLetterStudents(id, studentIds) {
    return api.put(`/feedback-letters/${id}/students`, { student_ids: studentIds }).then(r => r.data);
}

export function setLetterFrontSheet(letterId, studentId, json) {
    return api
        .put(`/feedback-letters/${letterId}/students/${studentId}/front-sheet`, { front_sheet_json: json })
        .then(r => r.data);
}

export function setLetterBackSheet(letterId, studentId, json) {
    return api
        .put(`/feedback-letters/${letterId}/students/${studentId}/back-sheet`, { back_sheet_json: json })
        .then(r => r.data);
}

export function finalizeLetter(id, finalized) {
    return api
        .post(`/feedback-letters/${id}/finalize`, { finalized })
        .then(r => r.data);
}